<template>
  <div id="estimate-config-modal" class="modal" v-show="modalShown"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2>見積もり設定</h2>
      </div>
      <div class="data-area">
        <div class="error_message">{{ errorMessage.text }}</div>
        <ul>
          <li>
            <span class="label">見積書記載企業名</span>
            <input type="text" v-model="estcfgCorpName">
          </li>
          <li>
            <span class="label">お支払い条件</span>
            <input type="text" v-model="estcfgCondition">
          </li>
          <li>
            <span class="label">お見積り有効期限(日数)</span>
            <input type="text" v-model="estcfgExpirationDays">
          </li>
          <li>
            <span class="label">備考1</span>
            <input type="text" v-model="estcfgRemark1">
          </li>
          <li>
            <span class="label">備考2</span>
            <input type="text" v-model="estcfgRemark2">
          </li>
          <li>
            <span class="label">備考3</span>
            <input type="text" v-model="estcfgRemark3">
          </li>
          <li>
            <span class="label">備考4</span>
            <input type="text" v-model="estcfgRemark4">
          </li>
        </ul>
      </div>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['estcfgCorpName'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['estcfgCondition'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['estcfgExpirationDays'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['estcfgRemark1'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['estcfgRemark2'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['estcfgRemark3'] }}</p>
      <p class="error_message" v-if="validateErrorMessages && Object.keys(validateErrorMessages).length > 0">{{ validateErrorMessages['estcfgRemark4'] }}</p>
      <div class="button-area">
      <button type="button" class="main_btn" @click="onUpdate">設定</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as AppUtil from '../../utils/App'
import {API_URL} from '../../constants/App'
export default {
  name: 'EstimateConfigModal',
  props: {
    prevDialog: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** 見積もり設定 */
      estcfgCorpName: null,
      estcfgCondition: null,
      estcfgExpirationDays: null,
      estcfgRemark1: null,
      estcfgRemark2: null,
      estcfgRemark3: null,
      estcfgRemark4: null,
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    onCancel: function () {
      this.modalShown = false
      this.prevDialog()
    },
    onUpdate: function () {
      let payload = {
        estcfgCorpName: this.estcfgCorpName,
        estcfgCondition: this.estcfgCondition,
        estcfgExpirationDays: this.estcfgExpirationDays,
        estcfgRemark1: this.estcfgRemark1,
        estcfgRemark2: this.estcfgRemark2,
        estcfgRemark3: this.estcfgRemark3,
        estcfgRemark4: this.estcfgRemark4
      }
      axios.post(API_URL.ADMIN + '/update-estimate-conf', payload
      ).then(response => {
        let modalData = {
          messages: ['変更しました'],
          onOk: () => {
            this.modalShown = false
            this.prevDialog()
          }
        }
        this.errorMessage = {}
        this.validateErrorMessages = {}
        AppUtil.showModal(modalData)
      }).catch(error => {
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    getEstimate: function () {
      axios.get(API_URL.ADMIN + '/get-estimate-conf'
      ).then(response => {
        let data = response.data.data
        this.estcfgCorpName = data.estcfgCorpName
        this.estcfgCondition = data.estcfgCondition
        this.estcfgExpirationDays = data.estcfgExpirationDays
        this.estcfgRemark1 = data.estcfgRemark1
        this.estcfgRemark2 = data.estcfgRemark2
        this.estcfgRemark3 = data.estcfgRemark3
        this.estcfgRemark4 = data.estcfgRemark4
      }).catch(error => {
        Api.handleError(error)
      })
    }
  },
  created: function () {
    this.getEstimate()
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
.count_limit{
  font-size: 8px;
}
.error_message {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/EstimateConfigModal.vue